import styled, { css } from 'styled-components';
import { getColor } from 'core/utils/Styles';

export const FullContainer = styled.div`
	background: ${getColor('white')};
	padding: 15px 30px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	border-radius: 4px;
`;
